import getFileProviderAuthHeaderValue from './getFileProviderAuthHeaderValue';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

export default async function callFileProviderAPI(
    url: string,
    providerType: AttachmentDataProviderType,
    optionalParams: {
        forceTokenRefresh?: boolean;
        requestInit?: RequestInit;
    } = { forceTokenRefresh: false, requestInit: {} }
): Promise<Response> {
    const forceTokenRefresh = optionalParams.forceTokenRefresh;
    const requestInit = optionalParams.requestInit || {};

    const authHeader = await getFileProviderAuthHeaderValue(providerType, forceTokenRefresh);
    if (!requestInit.headers) {
        requestInit.headers = new Headers();
    }

    (<Headers>requestInit.headers).set('Authorization', authHeader);

    const response: Response = await fetch(url, requestInit);

    return response;
}
